import './SideNav.css';const sideNav = "_sideNav_pt23o_1";
const sideNav__button = "_sideNav__button_pt23o_37";
const styles = {
  sideNav,
  "sideNav--hidden": "_sideNav--hidden_pt23o_34",
  sideNav__button
};
export {
  styles as default,
  sideNav,
  sideNav__button
};
